import { render, staticRenderFns } from "./HrPositions.vue?vue&type=template&id=8edc112e&"
import script from "./HrPositions.vue?vue&type=script&lang=js&"
export * from "./HrPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports